import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MetaCoreModule } from '@qtek/libs/meta-core';
import { TranslateCorePipe } from './pipes/translate-core.pipe';

@NgModule({
  declarations: [TranslateCorePipe],
  imports: [CommonModule, MetaCoreModule],
  exports: [TranslateCorePipe],
})
export class TranslationCoreModule {}
